var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mb-3 pl-1 py-5",class:_vm.buttonClass,attrs:{"color":_vm.buttonColor,"disabled":_vm.disabled},on:{"click":_vm.signin}},[_c('v-icon',{attrs:{"large":""}},[_vm._v(" "+_vm._s(_vm.buttonIcon)+" ")]),_vm._v(" Sign in with "+_vm._s(_vm.providerName)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }